/**
 * Created by mauget on 3/7/16.
 */

// ControlCollection.js

import { Collection }   from 'backbone';

//===============================================================
// A Backbone collection of editor control models.
// Each model has a reference to the page name, thumbnail, and
// information about each kind of contained object.
//
// -Lou Mauget, March 7, 2016
//===============================================================
class ControlCollection extends Collection {

    initialize() {
    }


}
const controlCollection = new ControlCollection();
export default controlCollection;
